import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-our-other-services',
  templateUrl: './our-other-services.component.html',
  styleUrls: ['./our-other-services.component.scss']
})
export class OurOtherServicesComponent implements OnInit {

  environment1 = environment.s3bucket.url;
  constructor() { }

  ngOnInit(): void {
  }
  customOptions: OwlOptions = {
    // loop: true,
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 24,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`
   ],
    responsive: {
      0: {
        items: 1.3,
        nav:false
      },
      400: {
        items: 2,
        nav:false
      },
      600: {
        items: 3,
        nav:false
      },
      940: {
        items: 3.9
      },
      1199:{
        items: 3.9
      }
    },
    nav: true
  }


}
